import { UserManagementPage } from "../userManagement/@userManagement.page";
import { AdminImportFabricPage } from "./fabricImport.admin.page";
import AdminFabricUploadPage from "./fabricUpload.admin.page";
import { AdminResetInventoryPage } from "./inventory-reset.admin.page";
import { AdminUpdateInventoryPage } from "./inventoryUpdate.admin.page";
// import { AdminRefreshDataFromProductionPage } from "./refreshDataFromProduction.admin.page";

const AdminConfig = {
  routes: [
    {
      path: "/admin/fabric",
      element: <AdminFabricUploadPage />,
    },
    {
      path: "/admin",
      element: <AdminImportFabricPage />,
    },
    {
      path: "/admin/importFabric",
      element: <AdminImportFabricPage />,
    },
    {
      path: "/admin/updateInventory",
      element: <AdminUpdateInventoryPage />,
    },
    {
      path: "/admin/resetInventory",
      element: <AdminResetInventoryPage />,
    },
    {
      path: "/admin/user-management",
      element: <UserManagementPage />,
      // specialAccessEmail: "jeff-weigang@ergos.com",
    },
    // {
    //   path: '/admin/refreshDataFromProduction',
    //   element: <AdminRefreshDataFromProductionPage />,
    // },
  ],
};

export default AdminConfig;
